export enum MediaType {
    // Set unknown to 0, everthing else is incremented by 1 at that point
    Unknown = 0,
    Image,
    Video,
    Document,
    Music,
    Link,
}
